// extracted by mini-css-extract-plugin
module.exports = {"calc_solarpanel":"portable-power-station-calculator_calc_solarpanel__FVwIv"};